<script setup lang="ts">
import { useCmsTranslations, useProductPrice } from "@shopware/composables";
import { defu } from "defu";
import { toRefs } from "vue";
import type { Schemas } from "#shopware";

const props = defineProps<{
  product: Schemas["Product"];
}>();

type Translations = {
  listing: {
    variantsFrom: string;
    previously: string;
    from: string;
    to: string;
  };
};

let translations: Translations = {
  listing: {
    variantsFrom: "variants from",
    previously: "previously",
    from: "from",
    to: "to",
  },
};

translations = defu(useCmsTranslations(), translations) as Translations;

const { product } = toRefs(props);

const {
  price,
  unitPrice,
  displayFromVariants,
  displayFrom,
  isListPrice,
  regulationPrice,
} = useProductPrice(product);
</script>

<template>
  <div class="product-list-price" :id="product.id">
    <SwSharedPrice v-if="unitPrice" :class="{ 'old-price': isListPrice}" :value="unitPrice" />
    <template v-if="!isListPrice">
      <div class="h-6"><!-- placeholder --></div>
    </template>
    <SwSharedPrice
      class="current-price"
      v-if="displayFromVariants"
      :value="displayFromVariants"
    >
      <template #beforePrice
        ><span v-if="displayFromVariants" class="text-sm">{{
          translations.listing.variantsFrom
        }}</span></template
      >
    </SwSharedPrice>
    <SwSharedPrice
      class="text-gray-900 basis-2/6"
      :class="{
        'current-price': isListPrice,
        'justify-end text-xl':
          regulationPrice || !regulationPrice || !displayFromVariants,
      }"
      :value="price?.listPrice?.price"
    >
      <template #beforePrice
        ><span v-if="displayFrom || displayFromVariants" class="text-sm">{{
          translations.listing.to
        }}</span></template
      >
    </SwSharedPrice>
    <template v-if="regulationPrice">
      <div class="text-xs flex text-gray-500">
        {{ translations.listing.previously }}
        <SharedPrice class="ml-1" :value="regulationPrice" />
      </div>
    </template>
    <template v-if="!regulationPrice">
      <div class="h-4"><!-- placeholder --></div>
    </template>
  </div>
</template>
